import clientInvoices from '../../../API/Client/GetInvoices'
import Excel from 'exceljs'
import {saveAs} from "file-saver";
import checkJwt from './../../../Global/jwtChecker' 
import logout from './../../../Global/logout' 


export default async function SearchedInvoicesToExcel(
    pickedPosProstor,
    pickedNapUred,
    startDate,
    endDate
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    const invoices = await clientInvoices(
        1, 
        50000, 
        pickedPosProstor, 
        pickedNapUred,
        startDate,
        endDate,
        false
      )

    if(!invoices.error ){  
        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet("Racuni");   

        let tableRowData = []
        invoices.data.invoices.forEach(function(item, index) { 
            tableRowData.push([
                item.invoice_no + "/" + item.invoice_business_premises_label + "/" + item.invoice_billing_device_isu,
                item.invoice_business_premises_label,
                item.invoice_no,
                item.invoice_date,
                item.JIR,
                item.ZKI,
                item.client_address,
                item.client_name,
                item.client_oib,
                item.fiscalization_request_uuid,
                item.in_VAT_system ? "Da" : "Ne",
                item.uuid,
                item.invoicebusinesspremises,
                item.means_of_payment,
                item.tax[0].tax_base,               
                item.tax[0].tax_amount,
                item.invoice_amount                
            ])
            
        })
        
        worksheet.addTable({
            name: 'Racuni',
            ref: 'A1',
            headerRow: true,
            style: {
              theme: 'TableStyleLight15',
              //showRowStripes: true,
            },
            columns: [
              { name: 'Br.', filterButton: true },
              { name: 'Poslovni prostor'},
              { name: 'Red. Br', filterButton: true },
              { name: 'Datum izdavanja', filterButton: true },
              { name: 'JIR',filterButton: true },
              { name: 'ZKI', filterButton: true },
              { name: 'Adresa Klijenta',  filterButton: true },
              { name: 'Naziv Klijenta', filterButton: true },
              { name: 'OIB Klijenta', filterButton: true },
              { name: 'Fskalizacijski UUID', filterButton: true },
              { name: 'Sustav poreza', filterButton: true },
              { name: 'Uređaj ISU', filterButton: true },
              { name: 'Adresa prostora', filterButton: true },
              { name: 'Način plačanja', filterButton: true },
              { name: 'Osnovica', filterButton: true },
              { name: 'Porez', filterButton: true },
              { name: 'Iznos', filterButton: true },
            ],
            //rows: []
            rows: tableRowData,
          });

        const buffer = await workbook.xlsx.writeBuffer();
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const fileExtension = '.xlsx';

        const blob = new Blob([buffer], {type: fileType});

        saveAs(blob, 'Racuni' + fileExtension);
    }                        
}